import PropTypes from "prop-types";

import Table from "../../../Common/Table";

function ArchivedStudentListTableBody({
  data,
  columns,
  pageSize,
  itemsCount,
  currentPage,
  onPageChange,
  handlerOnSelectArchiveStudentLists,
}) {
  return (
    <Table
      data={data}
      columns={columns}
      pageSize={pageSize}
      itemsCount={itemsCount}
      currentPage={currentPage}
      addSelectionColumn={true}
      onPageChange={onPageChange}
      tableSelector="viewport-archived-student-table"
      handlerOnSelectRows={handlerOnSelectArchiveStudentLists}
      propsBody={{ className: "min-h-15rem h-screen-footer-xl" }}
    />
  );
}

ArchivedStudentListTableBody.propTypes = {
  pageSize: PropTypes.number,
  itemsCount: PropTypes.number,
  currentPage: PropTypes.number,
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  onPageChange: PropTypes.func.isRequired,
  handlerOnSelectArchiveStudentLists: PropTypes.func.isRequired,
};

export default ArchivedStudentListTableBody;
